import { useState, useEffect } from "react";

/**
 * The current time, refreshed at the start of every minute — so anything priced
 * by time of day (night pricing) switches over at midnight without a reload.
 * One timer per page, no network: it only re-renders.
 */
export function useMinuteTick() {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    let interval;
    // Align to the minute boundary, then tick every 60s. India's +5:30 offset
    // keeps minute boundaries aligned with UTC ones.
    const timeout = setTimeout(() => {
      setNow(Date.now());
      interval = setInterval(() => setNow(Date.now()), 60000);
    }, 60000 - (Date.now() % 60000));
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, []);
  return now;
}
